export const cipActionSchema: any = {
  cipId: "",
  title: "",
  description: "",
  owner: "",
  startDate: "",
  endDate: "",
  status: "true",
  attachments: [],
  activityUpdate: [],
  locationId: "",
};
